export default "__VITE_ASSET__Dq0aHPB4__"